module.exports = __webpack_public_path__ + "static/img/jacket_tr.026481ab.png";